import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadCrumbsComponent } from './bread-crumbs.component';
import { LoadingModule } from 'src/app/Global/loading/loading.module';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [BreadCrumbsComponent],
  imports: [CommonModule, LoadingModule, TranslateModule, RouterModule],
  exports: [BreadCrumbsComponent],
})
export class BreadCrumbsModule {}
